import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
const CodeBlockContext = React.createContext({});
export function CodeBlockHandlerProvider({ children, artifactRunId, onProposalSelect, onProposalSubmit, MarkdownRenderer, }) {
    const value = useMemo(() => ({ artifactRunId, onProposalSelect, onProposalSubmit, MarkdownRenderer }), [artifactRunId, onProposalSelect, onProposalSubmit, MarkdownRenderer]);
    return _jsx(CodeBlockContext.Provider, { value: value, children: children });
}
export function useCodeBlockContext() {
    return React.useContext(CodeBlockContext);
}
//# sourceMappingURL=CodeBlockContext.js.map